// CANONICAL COPY (GH #7115). src/constants/obligations/obl-continual-improvement.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-continual-improvement',
  title: 'Review continual improvement and corrective actions',
  description:
    'Verify that the organisation continually improves the suitability, adequacy and effectiveness of the ISMS and reacts to nonconformities with corrective actions. Review the corrective action (CAPA) register, root-cause analyses, effectiveness checks and retained evidence.',
  category: 'governance',
  scfIds: ['SCF-MSS-007'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Continual improvement / corrective action register is published',
    },
    { type: 'document-within-sla', description: 'Register review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
